import { connect } from 'react-redux';
import TrainingPage from 'pages/TrainingPageNew';
import homePageNewActions from 'store/homePageNew/actions';
import newOlsActions from 'store/newOls/actions';

const mapStateToProps = state => {
  return {
    userPackages: state.homePageNew.userPackages,
    sessions: state.homePageNew.sessions,
    isSessionsLoading: state.homePageNew.loadingSessions,
    isPackagesLoading: state.homePageNew.loadingPackages,
    profileDetails: state?.auth?.profile,
    sessionIsRequesting: state?.homePageNew?.sessionIsRequesting,
  };
};
const mapDispatchToProps = {
  loadUserPackages: homePageNewActions.Creators.loadUserPackagesRequest,
  loadSessionsNew: homePageNewActions.Creators.loadSessionsNewRequest,
};
export default connect(mapStateToProps, mapDispatchToProps)(TrainingPage);
